import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  readonly size?: 'sm' | 'md';
  readonly loading?: boolean;
  readonly children: ReactNode;
}

/**
 * Boton base.
 *
 * Mientras `loading` esta activo el boton queda deshabilitado: la mayoria de
 * las acciones de este producto (crear un codigo, invitar) no son idempotentes
 * y un doble clic crearia dos.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={['qr-button', `qr-button--${variant}`, `qr-button--${size}`, className]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="qr-button__spinner" aria-hidden="true" /> : null}
      {children}
    </button>
  );
}
